import React from 'react'
import { Spin } from "antd";
import './styles.css'
import { useTranslation } from 'react-i18next'

export default ({ loading = false, tip = "loading", children }) => {
  const { t } = useTranslation(['common'])
  return <Spin tip={t(tip)} size="default" spinning={loading}>{children}</Spin>
}